import React, { useState } from 'react';
import { useLanguage } from './LanguageContext';
import { translations } from './translations';
import { getWhatsAppUrl } from './utils/whatsapp';
import './FaceliftComparison.css';

const ArrowsIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 17L3 12M3 12L8 7M3 12H21M16 17L21 12M21 12L16 7" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default function FaceliftComparison() {
  const [sliderPos, setSliderPos] = useState(50);
  const { language } = useLanguage();
  const t = translations[language];
  const whatsappUrl = getWhatsAppUrl(language);

  // Images for Face Lifting
  const beforeImg = '/surgeriesfolder/lifting-facial-before.webp';
  const afterImg = '/surgeriesfolder/lifting-facial-after.webp';

  const handleSliderChange = (e) => {
    setSliderPos(e.target.value);
  };

  return (
    <section className="facelift-section">
      <div className="facelift-inner">
        <div className="facelift-slider-container">
          {/* AFTER Image (Background) */}
          <img src={afterImg} alt={`${t.afterLabel || 'AFTER'} Face Lifting`} className="facelift-img facelift-img-after" loading="lazy" />
        
        {/* BEFORE Image (Foreground clipped) */}
        <img 
          src={beforeImg} 
          alt={`${t.beforeLabel || 'BEFORE'} Face Lifting`} 
          className="facelift-img facelift-img-before" 
          style={{ clipPath: `inset(0 ${100 - sliderPos}% 0 0)` }}
          loading="lazy" 
        />

        {/* Badges */}
        <span className="facelift-badge before">{t.beforeLabel || 'BEFORE'}</span>
        <span className="facelift-badge after">{t.afterLabel || 'AFTER'}</span>

        {/* Slider visuals */}
        <div className="facelift-slider-line" style={{ left: `${sliderPos}%` }}></div>
        <div className="facelift-slider-button" style={{ left: `${sliderPos}%` }}>
          <ArrowsIcon />
        </div>

        {/* Invisible Range Input for Interaction */}
        <input 
          type="range" 
          min="0" 
          max="100" 
          value={sliderPos} 
          onChange={handleSliderChange} 
          className="facelift-slider"
          aria-label="Image comparison slider"
        />
      </div>

      <div className="facelift-text-container">
        <h2 className="facelift-title">{t.faceliftTitle || 'FACE LIFTING'}</h2>
        <p className="facelift-description">
          {t.faceliftDesc}
        </p>
        <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="facelift-button">
          {t.bookConsultation || 'SCHEDULE A CONSULTATION'}
        </a>
      </div>
      </div>
    </section>
  );
}
